
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { getAuthUrl } from "@/utils/redirectUtils";

const BeginnerHero = () => {
  return (
    <section className="pt-32 pb-20 px-4 bg-gradient-to-b from-blue-50 to-white border-b border-blue-100">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:w-1/2 space-y-6">
            <Badge className="px-3 py-1 text-sm bg-blue-600 text-white border-blue-700">
              Perfect for Beginners
            </Badge>
            
            <h1 className="text-4xl md:text-6xl font-bold leading-tight">
              Finally, Google Ads <span className="text-blue-600">Made Easy</span>
            </h1>
            
            <p className="text-xl text-muted-foreground">
              No more confusion, wasted money, or overwhelming complexity. Our platform demystifies Google Ads and prevents costly mistakes, getting your first campaign live in just 5 minutes.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                size="lg" 
                className="text-lg px-8 h-14 bg-blue-600 hover:bg-blue-700 font-bold"
                onClick={() => window.location.href = getAuthUrl()}
              >
                Start Your First Campaign <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="text-lg px-8 h-14 border-blue-600 text-blue-700 hover:bg-blue-50"
                onClick={() => window.location.href = "/pricing"}
              >
                See Pricing
              </Button>
            </div>
            
            <p className="text-muted-foreground text-sm">
              Free plan forever. No credit card required.
            </p>
          </div>
          
          <div className="lg:w-1/2 rounded-xl overflow-hidden shadow-2xl border border-blue-200 bg-white">
            <div className="p-4 relative">
              <div className="bg-white rounded-full shadow-md flex items-center px-4 py-3 mb-4 border border-gray-200">
                <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path>
                </svg>
                <div className="ml-3 text-gray-700 font-medium">google ads for beginners</div>
              </div>
              
              <div className="mb-6">
                <div className="flex items-center mb-1">
                  <div className="text-xs border border-blue-700 text-blue-700 px-2 py-0.5 rounded mr-2">Ad</div>
                  <div className="text-xs text-gray-500">https://www.upfixe.com/beginners</div>
                </div>
                <h3 className="text-xl font-medium text-blue-700 mb-1">Easy Google Ads for Beginners | Create Ads in Minutes</h3>
                <p className="text-sm text-gray-600 mb-1">No experience needed. Create your first Google Ad campaign in 5 minutes. Professional results without the learning curve.</p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full">Free Plan</span>
                  <span className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full">Beginner Friendly</span>
                  <span className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full">AI-Powered</span>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <div className="text-xs text-gray-500 mb-1">https://www.somerandomsite.com/google-ads</div>
                  <h3 className="text-lg font-medium text-blue-600 mb-1">Google Ads Guide for Beginners: Complete Tutorial</h3>
                  <p className="text-sm text-gray-600">A comprehensive guide to Google Ads for beginners. Learn how to set up and optimize your first campaign step by step...</p>
                </div>
                
                <div>
                  <div className="text-xs text-gray-500 mb-1">https://www.anotherblog.com/learn-google-ads</div>
                  <h3 className="text-lg font-medium text-blue-600 mb-1">Learn Google Ads: Beginner's Guide to PPC</h3>
                  <p className="text-sm text-gray-600">This tutorial covers everything you need to know to get started with Google Ads, including account setup, keyword research...</p>
                </div>
              </div>
              
              <div className="absolute top-0 left-0 w-full h-full flex items-start justify-center">
                <div className="bg-blue-600 text-white py-2 px-6 rounded-b-lg shadow-xl text-sm font-bold">
                  Your ad will stand out like this
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeginnerHero;
